const ASSETS = {
  voyages: require("./voyages.png").default,
  influens: require("./influens.png").default,
  cv: require("./diar_ihza_cv.pdf").default,
  resume: require("./diar_ihza_resume.pdf").default
};

export default ASSETS;
